// TODO Draw target order data based on whether we use synthetic data or not
import { scaleLinear, scalePoint, scaleTime, extent } from "d3";
import {
  accessors,
  filterAssociation,
  setFromArrayValues,
  CHART_DIMENSIONS,
} from ".";
import { BLANK_AXIS_NAME } from "./constants";

// Scale generator - Returns a scale object, keyed by narrative
/**
 *
 * @param {} config.yOrder
 * An array with N objects formatted like:
 * [
 *  {fieldA: value, fieldB: otherValue},
 *  {fieldA: value, fieldB: otherValue},
 * ]
 *
 * If found in the config, it quantizes the y-axis into N segments
 * and places the corresponding VALUE in the corresponding FIELD (z-axis)
 */
export const scales = (
  data,
  config = { yOrder: [], associations: [], width: CHART_DIMENSIONS.X.MAX }
) => {
  // const allEventTypes = setFromArrayValues(data, (d) => d.event.type);

  // First case defines the order in a hardcoded manner,
  // while the second is data - driven
  const allAssociations =
    config.associations || setFromArrayValues(data, accessors.association);

  // const allAssociations = setFromArrayValues(data, accessors.association);

  // hardcoded and in order
  // const allAssociations = new Set(COUNTRIES);

  // optional global, or data-derived time
  const dateRange = config.globalTime
    ? [config.globalTime.start, config.globalTime.end]
    : extent(data, accessors.date.start);

  const z = scalePoint()
    .domain(allAssociations)
    .range([CHART_DIMENSIONS.Z.MIN, CHART_DIMENSIONS.Z.MAX]);
  const r = scaleLinear().domain([0, 1]).range([0.01, 0.07]);
  const associations = {};
  allAssociations.forEach((assoc) => {
    const filtered = data.filter(filterAssociation(assoc));
    let targets;

    if (config.yOrder) {
      // hardcoded
      targets = config.yOrder.map((d, i) =>
        d[assoc] !== "" ? d[assoc] : `${BLANK_AXIS_NAME}-${i}`
      );
    } else {
      // parametric construction of targets
      targets = setFromArrayValues(
        filtered,
        accessors.target.name,
        accessors.target.association
      );
    }

    associations[assoc] = {
      data: filtered,
      y: scalePoint()
        .domain(targets)
        .range([CHART_DIMENSIONS.Y.MIN, targets.length * 0.5]),
      z,
      r,
    };
  });

  let fieldsByTarget;
  if (config.yOrder && config.associations) {
    fieldsByTarget = config.yOrder.reduce((acc, curr) => {
      config.associations.forEach((country) => {
        const name = curr[country];
        acc = {
          ...acc,
          [name]: new Set([...(acc[name] || []), country]),
        };
      });
      return acc;
    }, {});
  } else {
    // TODO fallback if config.yOrder or config.associations doesn't exist
  }

  return {
    scales: {
      z,
      x: scaleLinear()
        .domain(dateRange)
        .range([CHART_DIMENSIONS.X.MIN, config.width]),
      time: scaleTime()
        .domain(dateRange)
        .range([CHART_DIMENSIONS.X.MIN, config.width]),
    },
    associations,
    fieldsByTarget,
  };
};
